module.exports = __webpack_public_path__ + "static/images/offers-click.3jXMokL.svg";